import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';


@Component({
  selector: 'app-employee-browse-dialog',
  standalone: false,
  templateUrl: './employee-browse-dialog.component.html',
  styleUrl: './employee-browse-dialog.component.scss'
})
export class EmployeeBrowseDialogComponent {
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['select', 'name'];
  selection: SelectionModel<any>;
  highlightedRows: any[] = [];
  showSelected: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EmployeeBrowseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dataSource = new MatTableDataSource<any>(data.employees);
    // Allow multi-select: pass array or empty array
    this.selection = new SelectionModel<any>(true, Array.isArray(data.selected) ? data.selected : (data.selected ? [data.selected] : []));
  }

  ngOnInit(): void {
    // No-op
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  showSelectedItems(): void {
    if (this.showSelected) {
      this.dataSource.data = this.data.employees.filter((item: any) => this.isRowSelected(item));
    } else {
      this.dataSource = new MatTableDataSource<any>(this.data.employees);
    }
  }

  isRowSelected(row: any): boolean {
    return this.selection.isSelected(row);
  }

  toggleRow(row: any): void {
    this.selection.toggle(row);
    this.highlightedRows = this.selection.selected;
  }

  selectRow(row: any): void {
    // Optionally keep this for row click selection
    this.selection.clear();
    this.selection.select(row);
    this.highlightedRows = [row];
  }

  save(): void {
    const selectedItems = this.selection.selected;
    console.log('Selected employees in dialog:', selectedItems); // <-- log selected employees
    this.dialogRef.close(selectedItems); // always return array
  }

  cancel(): void {
    this.dialogRef.close();
  }

  getEmployeeName(emp: any): string {
    if (!emp) return '';
    return `${emp.f_name || ''} ${emp.m_name || ''} ${emp.l_name || ''}`.replace(/\s+/g, ' ').trim();
  }

}
